import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import OptionPicker from "@/components/app/OptionPicker";
import ImageUploader from "@/components/app/ImageUploader";
import { categoryLabel, parsePrice, priceInput } from "@/lib/adega";

const PRICE = "[0-9]+([,.][0-9]{1,2})?";

function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function defaultPromoEnd() {
  const d = new Date();
  d.setHours(23, 59, 0, 0);
  return toLocalInput(d.toISOString());
}

export default function ProductForm({ initial, categories, onSubmit, submitLabel = "Adicionar" }) {
  const [f, setF] = useState({
    name: initial?.name || "", category: initial?.category || categories[0], description: initial?.description || "",
    price: priceInput(initial?.price), photo_url: initial?.photo_url || null,
    promo: !!initial?.promo, promo_price: priceInput(initial?.promo_price), promo_until: toLocalInput(initial?.promo_until) || defaultPromoEnd(),
  });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const body = { name: f.name, category: f.category, description: f.description, price: parsePrice(f.price), photo_url: f.photo_url };
    if (f.promo) Object.assign(body, { promo_price: parsePrice(f.promo_price), promo_until: new Date(f.promo_until).toISOString() });
    else if (initial?.promo) body.clear_promo = true;
    if (initial && !f.photo_url && initial.photo_url) body.clear_photo = true;
    setBusy(true);
    const ok = await onSubmit(body);
    setBusy(false);
    if (ok && !initial) setF((x) => ({ ...x, name: "", description: "", price: "", photo_url: null, promo: false, promo_price: "" }));
  };

  const cats = categories.includes(f.category) ? categories : [...categories, f.category];
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="product-form">
      <Input value={f.name} onChange={set("name")} placeholder="Nome (ex: Heineken)" required maxLength={60} data-testid="product-name-input" />
      <Input value={f.description} onChange={set("description")} placeholder="Descrição curta (ex: lata 350ml)" maxLength={80} data-testid="product-description-input" />
      <div className="grid grid-cols-2 gap-2">
        <OptionPicker value={f.category} onChange={(v) => setF({ ...f, category: v })} options={cats.map((c) => ({ value: c, label: categoryLabel(c) }))} testid="product-category-select" />
        <Input value={f.price} onChange={set("price")} inputMode="decimal" placeholder="Preço R$ 0,00" required pattern={PRICE} data-testid="product-price-input" />
      </div>
      <ImageUploader value={f.photo_url} onChange={(v) => setF({ ...f, photo_url: v })} square label="Foto (opcional)" testid="product-photo-uploader" aspect="aspect-square max-w-[110px]" />
      <div className="rounded-lg border border-white/10 p-3 space-y-2">
        <label className="flex items-center gap-3 text-sm">
          <Switch checked={f.promo} onCheckedChange={(v) => setF({ ...f, promo: v })} data-testid="product-promo-switch" /> Promoção do dia
        </label>
        {f.promo && (
          <div className="grid grid-cols-2 gap-2">
            <div><Label className="text-[11px]">Preço promo</Label><Input value={f.promo_price} onChange={set("promo_price")} inputMode="decimal" required pattern={PRICE} placeholder="R$ 0,00" data-testid="product-promo-price-input" /></div>
            <div><Label className="text-[11px]">Termina em</Label><Input type="datetime-local" value={f.promo_until} onChange={set("promo_until")} required data-testid="product-promo-until-input" /></div>
          </div>
        )}
      </div>
      <Button type="submit" disabled={busy} className="w-full h-12 press" data-testid="product-submit-button">{busy ? "Salvando..." : submitLabel}</Button>
    </form>
  );
}
